import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {fetchSuiteUsers, clearSuiteUsers, fetchPropertySuites, fetchSuiteCounts, addExistingUser} from '../../store/actions/suites';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { fetchContacts, saveContact, updateContact, deleteContactById } from '../../store/actions/contacts';

import { selectSuiteUsers } from '../../store/selectors/suiteUsers';
import SuiteUsersTable from '../../components/SuiteUsersTable';
import { upload } from '../../helpers/upLoadHelper';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { resetUserPassword,activateUser } from '../../store/actions/auth';
import Loader from '../../components/Loader';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { selectContacts } from '../../store/selectors/contacts';


class SuiteUsers extends Component {
  async componentDidMount() {
    const { suite, onFetchSuiteUsers, onClearSuiteUsers,onFetchContacts,contacts,user } = this.props;
    await onClearSuiteUsers();
    onFetchSuiteUsers(suite.id);
    onFetchContacts(user.id,user.roles[0].role.name);
  }

  onAddingExistingUser = data => {
    this.props.onAddingExistingUser(data)
  }

  onSubmitContactForm = async (data, actionType) => {
    const { user, onAddExistingUserToSuite } = this.props;    
    if(data.formType && data.formType === 'New'){
    let imageUrl=null
    if(data.selectedImage && data.selectedImage.length > 0){
      imageUrl =  await upload(data.selectedImage[0])
    }
    let assignedRoles = [];
    if(data.userRole){
      for (var i = 0; i < this.props.formOptions.allRoles.length; i++) {
        if (data.userRole === this.props.formOptions.allRoles[i].name) {
          assignedRoles.push(this.props.formOptions.allRoles[i].id)
        }
      }
    }
    if(!data.userRole){
      assignedRoles.push(data.roles[0].role.id)
    }

    let phone = data.phone;
    let cleaned = ('' + phone).replace(/\D/g, '');
    let formattedNumber = cleaned;
    if(cleaned.length  === 10){
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      formattedNumber =   match[1] + '-' + match[2] + '-' + match[3];
    }
    let firstChar = data.firstname.charAt(0)?.toUpperCase();
    let slicedName = data.firstname.slice(1, data.firstname.length);
    let firstname = firstChar + slicedName

    if(data.id){
      let params ={


        "id": data.id,
       "username": data.username,
       "email": data.email,
       "firstname": firstname,
       "lastname": data.lastname,
       "phone": formattedNumber,
       "profileImage": imageUrl!= null ? imageUrl : data.profileImage,
       "SuiteId": this.props.suite.id,
       "PropertyId": this.props.suite.propertyId,
       "isPrimaryContact": data && data.isPrimaryContact && data.isPrimaryContact === true ? true : false,
       "languages": null,
       "customerId": null,
       "deleted": false,
       "assignedRoles": assignedRoles,
       "address": data.address,
       "UserId": user.id,
       "SendActivationLink":(data.status && data.status === 'Created'&&data.sendActivationEmail) ? data.sendActivationEmail : false,
       "IsMultiSelect":false,
       "RoleName": data.userRole,
       "RoleId": assignedRoles[0],
       "isDashboardAccess":data.isDashboardAccess
      }
      if(data.userRole === 'Home Owner' || data.userRole === "Realtor"){
        params.Suites = [{
                          Id:this.props.suite.id,
                          PropertyId: this.props.suite.propertyId
        }]
      }else{
        params.SuiteId = this.props.suite.id;
      }
      
      await this.props.onUpdateContactForm(params,'', 'suiteUser')
      this.onfetchSuiteData();
      // this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name)
      //this.props.onFetchPropertySuites(this.props.suite.propertyId, user.id, user.roles[0].role.name);
      setTimeout(() => {
        this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name)
        this.props.onFetchPropertySuites(this.props.property.propertyId, user.id, user.roles[0].role.name)
        },1000);
    }else{
      let params = {
        "username": data.email,
        "email": data.email.trim(),
        "firstname": firstname,
        "lastname": data.lastname,
        "phone": formattedNumber,
        "profileImage": imageUrl,
        
        "languages": null,
        "customerId": null,
        "SuiteId": this.props.suite.id,
        "PropertyId": this.props.suite.propertyId,
        "isPrimaryContact": data && data.isPrimaryContact && data.isPrimaryContact === true ? true : false,
        "SentEmail": true,
        "assignedRoles": assignedRoles,
        "address":data.address,
        "UserId": user.id,
        "SendActivationLink":data.sendActivationEmail ? data.sendActivationEmail : false,
        "IsMultiSelect":false,
        "RoleName": data.userRole,
        "RoleId": assignedRoles[0],
        "isDashboardAccess":data.isDashboardAccess
      }

      if(data.userRole === 'Home Owner' || data.userRole === "Realtor"){
        params.Suites = [{
          Id:this.props.suite.id,
          PropertyId: this.props.suite.propertyId
         }]
      }else{
        params.SuiteId = this.props.suite.id;
      }
          await this.props.onSubmitContactForm(params, 'suiteUser', actionType);
          this.onfetchSuiteData();
         setTimeout(() => {
          this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name)
          this.props.onFetchPropertySuites(this.props.property.propertyId, user.id, user.roles[0].role.name, false)
          },1000);
      if(actionType === 'saveAndAdd') {
       // this.props.clearContactFormData();
      }
    }
  }
    else{
      let params={
        "SuiteId": this.props.suite.id,
        "PropertyId": this.props.suite.propertyId,
        "Role": data.role,
        "UserId": data.selectedUserId,
        "CreatedBy": user.id,
        "IsPrimaryContact": data.isPrimaryContact && data.isPrimaryContact === true ? true : false
      }      
      await onAddExistingUserToSuite(params, actionType);
      this.onfetchSuiteData();
      // this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name)
      setTimeout(() => {
      this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name)
      this.props.onFetchPropertySuites(this.props.property.propertyId, user.id, user.roles[0].role.name, false)
      },1000);
    }
  }
  sendResetPasswordLinkToUser = data => {
    this.props.resetUserPassword(data)
   }
   sendActivationLinkToUser = data => {
    this.props.activateUser(data,{
      "UserId":data.id
    })
  }
  onDeleteContactById = async (data) => {
    await this.props.onDeleteContactById(data.id)
    this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name)
  }
  onfetchSuiteData = () => {
    this.props.onFetchSuiteData();
  }
  render() {
    const { suiteUsers, setSearch, loader } = this.props;
    return (
      loader ? <Loader /> :
      <SuiteUsersTable
          suite={this.props.suite} 
          contacts={suiteUsers}
          onSubmitContactForm={this.onSubmitContactForm}
          onAddingExistingUser={this.onAddingExistingUser}
          sendResetPasswordLinkToUser={ (data) =>this.sendResetPasswordLinkToUser(data)}
          sendActivationLinkToUser={(data) =>this.sendActivationLinkToUser(data)}
          onDeleteContact={(data) => this.onDeleteContactById(data)}
          onSearch={e => setSearch({ suiteUsers: e.target.value.trim() })}
      />
    )
    }

}

const mapStateToProps = (state, ownProps) => {
  let user = selectAuthenticatedUser(state);
  return {
    user,
    suiteUsers: selectSuiteUsers(state),
    formOptions:selectFormOptions(state),
    loader: selectPRLoader(state),
    contacts:selectContacts(state)
  }
  // loader: selectPRLoader(state),
  
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onSubmitContactForm: saveContact,
  onUpdateContactForm:updateContact,
  onFetchPropertySuites: fetchPropertySuites,
  onDeleteContactById:deleteContactById,
  onFetchSuiteUsers: fetchSuiteUsers,
  setSearch,
  clearSearch,
  // onFetchContacts:fetchContacts,
  resetUserPassword,
  activateUser,
  onClearSuiteUsers: clearSuiteUsers,
  onFetchSuiteCounts: fetchSuiteCounts,
  onAddingExistingUser:addExistingUser,
  onFetchContacts: fetchContacts,
  onAddExistingUserToSuite: addExistingUser,
  onFetchPropertySuites: fetchPropertySuites
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteUsers);
